module.exports = __webpack_public_path__ + "static/img/eiCad_cover_3.013ba611.png";